// extracted by mini-css-extract-plugin
export default {"stars":"Stars_stars__EsStA","gray":"Stars_gray__d6DLu","gold":"Stars_gold__xrbDB"};